import { createContext } from 'react';
import { makeAutoObservable } from 'mobx';
import { UIStore } from './ui-store/UIStore';
import { ExcelStore } from './excel-store/ExcelStore';
import { HospitalFilesStore } from './modules/hospital-files/HospitalFilesStore';
import { PopupStore } from './popup-store/PopupStore';
import AuthStore from './auth-store/AuthStore';
import UserStore from './user-store/UserStore';
import { DashboardStore } from './dashboard/DashboardStore';
import { UserManagementStore } from './modules/user-management/UserManagementStore';
import { HospitalStore } from './modules/hospital/HospitalStore';
import { OvertimeStore } from './modules/overtime/OvertimeStore';
import { ExpenseStore } from './modules/expense/ExpenseStore';

export class RootStore {
  authStore: AuthStore;
  userStore: UserStore;
  uiStore: UIStore;
  excelStore: ExcelStore;
  hospitalFilesStore: HospitalFilesStore;
  popupStore: PopupStore;
  dashboardStore: DashboardStore;
  userManagementStore: UserManagementStore;
  hospitalStore: HospitalStore;
  overtimeStore: OvertimeStore;
  expenseStore: ExpenseStore;
  constructor() {
    this.authStore = new AuthStore(this);
    this.userStore = new UserStore(this);
    this.uiStore = new UIStore(this);
    this.excelStore = new ExcelStore(this);
    this.hospitalFilesStore = new HospitalFilesStore(this);
    this.popupStore = new PopupStore(this);
    this.dashboardStore = new DashboardStore(this);
    this.userManagementStore = new UserManagementStore(this);
    this.hospitalStore = new HospitalStore(this);
    this.overtimeStore = new OvertimeStore(this);
    this.expenseStore = new ExpenseStore(this);
    makeAutoObservable(this);
  }
}

export const RootStoreContext = createContext<RootStore>(new RootStore());
